import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Motion";
import { DISHES } from "@/data/content";

const SignatureDishes = () => (
  <section id="dishes" className="py-28 sm:py-36" data-testid="signature-dishes-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="flex flex-wrap items-end justify-between gap-8 mb-16 lg:mb-20">
        <div>
          <Reveal>
            <Overline className="text-wine">Made With Amore</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5">
              Signature <span className="italic text-wine">Dishes</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-xs text-faded text-sm font-light leading-relaxed">
            A taste of the menu — six plates our guests fall in love with, again and again.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16">
        {DISHES.map((dish, i) => (
          <Reveal key={dish.name} delay={(i % 3) * 0.12} y={50}>
            <article className="group cursor-pointer" data-testid={`dish-card-${i}`}>
              <div className="relative overflow-hidden rounded-[1.75rem]">
                <img
                  src={dish.img}
                  alt={dish.name}
                  loading="lazy"
                  className="img-lux w-full aspect-[4/5] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/25 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              </div>
              <div className="mt-6">
                <h3 className="font-serif text-2xl sm:text-[26px] font-medium tracking-tight group-hover:text-wine transition-colors duration-300">
                  {dish.name}
                </h3>
              </div>
              <p className="mt-2 text-faded text-sm font-light leading-relaxed">{dish.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 text-center">
          <Link
            to="/menu"
            data-testid="view-full-menu-btn"
            className="inline-block rounded-full border border-wine px-10 py-4 text-sm tracking-[0.16em] uppercase text-wine hover:bg-wine hover:text-cream transition-colors duration-300"
          >
            View the Full Menu
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default SignatureDishes;
